import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import LeadModel from "../../viewModels/Lead/LeadModel";
import createMessageModalSlice from "../../widgets/CreateMessageModal/reducer";
import { MessageDataConverter } from "../../viewModels/Message/MessageModel";
import { ChangeLeadStatusFormInput } from "./components/GeneralTab";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  lead: LeadModel;
} = {
  loading: true,
  loadingData: false,
  lead: undefined!,
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    loadLead(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
    loadLeadSuccess(state, action: PayloadAction<LeadModel>) {
      state.loading = false;
      state.loadingData = false;
      state.lead = action.payload;
    },

    loadLeadReject(state) {
      state.loading = false;
      state.loadingData = false;
    },

    changeLead(state, action: PayloadAction<LeadModel>) {
      state.lead = action.payload;
    },

    updateLead(state) {
      state.loadingData = true;
    },
    updateLeadSuccess(state, action: PayloadAction<LeadModel>) {
      state.loadingData = false;
      state.lead = action.payload;
    },
    updateLeadReject(state) {
      state.loading = false;
      state.loadingData = false;
    },

    changeLeadStatus(state, _action: PayloadAction<ChangeLeadStatusFormInput>) {
      state.loadingData = true;
    },

    resetState: () => initialState,
  },
  extraReducers(builder) {
    builder.addCase(createMessageModalSlice.actions.createMessageSuccess, (state, action) => {
      if (state.lead && state.lead.id === action.payload.leadId) {
        state.lead.messages = [MessageDataConverter.convertMessage(action.payload), ...state.lead.messages];
      }
    });
  },
});

export default leadSlice;
